import React from 'react';
import { Play, Pause, Square, Image as ImageIcon } from 'lucide-react';
import { Task, WorkOrder } from '../../types/workOrders';

interface TaskActionsProps {
    task: Task;
    workOrder: WorkOrder;
    isTaskCompleted: boolean;
    isWorkOrderCompleted: boolean;
    startTime: number | null;
    loading: boolean;

    // NEW
    isPaused: boolean;
    onPause: () => void;
    onResume: () => void;

    onShowGallery: () => void;
    onShowConfirmation: (type: 'start' | 'end') => void;
}

export function TaskActions({
    task,
    isTaskCompleted,
    isWorkOrderCompleted,
    startTime,
    loading,
    isPaused,
    onPause,
    onResume,
    onShowGallery,
    onShowConfirmation,
}: TaskActionsProps) {
    const disableAll = loading || isTaskCompleted || isWorkOrderCompleted;

    return (
        <div className='flex items-center gap-2 shrink-0'>
            {/* Gallery */}
            <button
                type='button'
                onClick={onShowGallery}
                disabled={disableAll}
                className='inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-light-border dark:border-dark-border hover:opacity-90 disabled:opacity-50'
            >
                <ImageIcon className='w-4 h-4' />
                {/* <span className='text-sm'>Photos</span> */}
            </button>

            {/* Start / Resume */}
            {!startTime && !isTaskCompleted && !isWorkOrderCompleted && (
                <button
                    type='button'
                    disabled={loading}
                    onClick={
                        isPaused ? onResume : () => onShowConfirmation('start')
                    }
                    className='inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-600 text-white hover:opacity-90 disabled:opacity-50'
                >
                    <Play className='w-4 h-4' />
                    <span className='text-sm'>
                        {isPaused ? 'Resume' : 'Start'}
                    </span>
                </button>
            )}

            {/* Pause */}
            {startTime && !isTaskCompleted && !isWorkOrderCompleted && (
                <button
                    type='button'
                    disabled={loading}
                    onClick={onPause}
                    className='inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-yellow-600 text-white hover:opacity-90 disabled:opacity-50'
                >
                    <Pause className='w-4 h-4' />
                    <span className='text-sm'>Pause</span>
                </button>
            )}

            {/* Complete */}
            {startTime && !isTaskCompleted && !isWorkOrderCompleted && (
                <button
                    type='button'
                    disabled={loading || (!startTime && !isPaused)}
                    onClick={() => onShowConfirmation('end')}
                    className='inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-red-600 text-white hover:opacity-90 disabled:opacity-50'
                >
                    <Square className='w-4 h-4' />
                    <span className='text-sm'>Complete</span>
                </button>
            )}
        </div>
    );
}
